import { Component, OnInit } from '@angular/core';
import { DataService } from './../../../services/data.service';

@Component({
  selector: 'app-my-settings',
  templateUrl: './my-settings.component.html',
  styleUrls: ['./my-settings.component.scss']
})
export class MySettingsComponent implements OnInit {
  userInfo: any;
  constructor(private dataSvc: DataService) { }

  ngOnInit() {
    this.userInfo = this.dataSvc.userDisplayInfo;
    console.log('User data in Client header', this.userInfo.UserRoleID);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-settings/my-settings.component.ts